import React, {useState, useEffect} from 'react'
import { Image, Container } from 'react-bootstrap'
import a7 from "../../../../assets/edgemarketing/a7.png"

import '../edgemarketing.css'


function Bannermockup() {

   const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth <= 768);
  
    useEffect(() => {
      const handleResize = () => {
        setIsSmallScreen(window.innerWidth <= 768);
      };
  
      window.addEventListener('resize', handleResize);
  
      return () => {
        window.removeEventListener('resize', handleResize);
      };
    }, []);

    const handleContextMenu = (e) => {
      e.preventDefault(); // Disable right-click
    };


  return (
    <Container 
    fluid 
    className='container-section' 
    style={{
      backgroundColor:"#252525",
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: isSmallScreen ? 'auto' : '100vh'
      }}>
       <Image src={a7} alt='a32' width={100+"%"} draggable="false" onContextMenu={handleContextMenu}  height="auto" />
    </Container>
    
     
    
  )
}

export default Bannermockup
